import { TopHeaderMenus } from "@header/TopHeader/TopHeaderMenus";
import { SocialMedia } from "@header/TopHeader/TopSocialMedia";
import type { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

export type TopHeaderProps = {
  testId?: string;
  className?: string;
};

export function TopHeader({
  testId = "topheader",
  className,
}: TopHeaderProps): ReactElement {
  return (
    <div className={twMerge("w-full bg-white hidden lg:block z-50", className)}>
      <div className="lg:max-w-7xl xmd:px-2.5 w-full mx-auto px-sm h-xxs">
        <div className="inline-block">
          <SocialMedia testId={testId} />
        </div>
        <div className="float-right inline-flex items-center font-primary gap-4 h-full ">
          <TopHeaderMenus />
        </div>
      </div>
    </div>
  );
}
